// extracted by mini-css-extract-plugin
module.exports = {"instagrid":"Instagrid_instagrid__dCLd_","marquee":"Instagrid_marquee__7TfQ0"};